import React, { Component, Fragment } from "react";
import "./ForgotPassword.scss";
import Logo from "../Logo/index";
import Tabs from "../Tabs/index";
import { ReactComponent as PasswordVisible } from "./icons/passwordvisible.svg";
import { ReactComponent as PasswordNotVisible } from "./icons/passwordNotVisible.svg";
import Button from "./Button";
import Rectangle from "./Rectangle";
import "./Rectangle.scss";
import { ToastContainer } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEmailFocused: false,
    };
  }
  render() {
    const {
      companyTypeTabButton,
      companyType,
      selectCompanyType,
      toggleForgotPassword,
      forgotPassword,
      email,
      handleEmailChange,
      shouldRenderCompanyTab,
      shouldEnableRecaptcha,
      verifyCallback,
      onExpire,
      reCaptchaKey
    } = this.props;
    return (
      <Fragment>
        {/* <Rectangle className={"otpRectangleTopL"} /> */}
        {/* <Rectangle className={"otpRectangleTopS"} /> */}
        <div className="forgotPasswordFormCardMain">
          <ToastContainer />
          <div className="forgotPasswordFormCard">
            <div className="forgotPasswordFormLogo">
              <Logo className="forgotPasswordLogoImage" />
            </div>
            {shouldRenderCompanyTab() && <div className="companyTypeButton">
              <Tabs
                tabs={companyTypeTabButton}
                activeTabId={companyType}
                selectTab={selectCompanyType}
              />
            </div>}
            <div className="forgotPasswordFormEmailMain">
              <p className="forgotPasswordFormEmailLable">Email</p>
              <div className={`forgotPasswordFormEmailBox ${this.state.isEmailFocused ? 'box-focused' : ''}`}>
                <input
                  type="text"
                  name="email"
                  className="forgotPasswordFormEmailInput"
                  value={email}
                  onChange={handleEmailChange}
                  onFocus={() => this.setState({ isEmailFocused: true })}
                  onBlur={() => this.setState({ isEmailFocused: false })}
                />
              </div>
            </div>

            {shouldEnableRecaptcha && shouldEnableRecaptcha() &&
              <div className="reCaptcha-container">
                <ReCAPTCHA
                  sitekey="6LcHtbwUAAAAAKkjbo7nNh9ajzF5GEHk9uC5skGG"
                  onChange={verifyCallback}
                  onExpired={onExpire}
                  key={reCaptchaKey}
                />
              </div>
            }

            <div className="forgotPasswordButtonBox">
              <Button
                Name={"Submit"}
                className={"forgotPasswordButton"}
                onClick={forgotPassword}
                value={"Submit"}
              />
            </div>
            <div className="forgotPasswordBackToSignInLableBox">
              <p
                className="forgotPasswordBackToSignInLable"
                onClick={toggleForgotPassword}
              >
                Back To SignIn
              </p>
            </div>
          </div>
        </div>
        {/* <Rectangle className={"otpRectangleBottomL"} /> */}
        {/* <Rectangle className={"otpRectangleBottomS"} /> */}
      </Fragment>
    );
  }
}
export default ForgotPassword;
